import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import SubNav from './sub-nav'
import { stringify } from 'querystring'
import Cookies from '@arsenal/arsenal/modules/Cookies'
import ArticleCard from './article-card'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination } from 'swiper'
import groupBy from 'lib/groupBy'
import { useCityName } from 'Components/hooks'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Link from 'next/link'
SwiperCore.use([Pagination])
import fetch from 'lib/decorated-fetch'
const show_more_icon = require('static/show-more.png')
const empty_icon = require('static/empty-envelope.png')
interface IArticles {
  series_id: number
}

interface IVideoInfo {
  repost_info: {
    title: string // 标题
    item_id_str: string // GID
    image_url: string // 封面
  }
  user_info: {
    avatar_url: string // 用户头像
    name: string // 昵称
    user_id: number
  }
  video_duration: number // 视频时长（单位s）
  comment_count?: number // 评论人数
  abstract_content: string
}
interface IArticleInfo {
  banner_type: 'live' | 'article'
  title: string
  cover_url: string
  user_info: {
    username: string
    avatar: string
  }
  uid: number
  unique_id_str: string
  comment_count: number
  abstract_content: string
}

export default function Articles(props: IArticles) {
  const { series_id } = props
  const [tabNow, setTabNow] = useState('article')
  const [articles, setArticles] = useState<IArticleInfo[]>([])
  const [videos, setVideos] = useState<IVideoInfo[]>([])
  const cityName = useCityName()
  useEffect(() => {
    const fetchData = async () => {
      const query = {
        series_id,
        city_name: cityName,
      }
      const json = await fetch(
        `/motor/m_api/pc_series_entrance_list?${stringify(query)}`
      ).catch((e) => {
        // no-op
      })
      setArticles(json?.data?.list?.map((item: any) => item.detail) || [])
    }
    try {
      fetchData()
    } catch (err) {
      console.error(err)
    }
  }, [])
  useEffect(() => {
    const web_id: any = Cookies('tt_webid') || ''
    const query = {
      concern_id: series_id,
      category: 'video',
      device_platform: 'web',
      channel: 'web',
      tt_from: 'enter_auto',
      web_id,
      motor_feed_extra_params: JSON.stringify({
        refresh_num: 0,
        loadmore_num: 0,
        feed_type: 0,
        new_feed: true,
      }),
      sub_category: 'video',
      impression_info: JSON.stringify({
        page_id: 'page_car_series',
        sub_tab: 'video',
      }),
      source: 'pc',
    }
    const fetchData = async () => {
      const json = await fetch(
        `/motor/stream_entrance/get_feed_pc/v47/?${stringify(query)}`
      ).catch((e) => {
        // no-op
      })
      setVideos(json?.data?.slice?.(0, 6)?.map((e: any) => e?.info) || [])
    }
    try {
      fetchData()
    } catch (err) {
      console.error(err)
    }
  }, [])

  const handleClick = useCallback((payload) => {
    setTabNow(payload)
  }, [])
  const tabs = useMemo(() => {
    const tabs = []
    if (articles.length > 0) {
      tabs.push({
        value: 'article',
        text: '文章',
      })
    }
    if (videos.length > 0) {
      tabs.push({
        value: 'video',
        text: '视频',
      })
    }
    if (tabs.length === 0) {
      tabs.push({
        value: 'article',
        text: '文章',
      })
    }
    setTabNow(tabs[0]?.value || '')
    return tabs
  }, [articles, videos])
  const paginationRef = useRef<HTMLDivElement>(null)
  const params = {
    pagination: {
      el: paginationRef.current,
      clickable: true,
    },
  }

  const cards = useMemo(() => {
    return groupBy(
      tabNow === 'article'
        ? articles.map((article) => (
          <ArticleCard
            {...article}
            key={article.unique_id_str}
            series_id={series_id}
          />
        ))
        : videos.map((video) => {
          const {
            repost_info,
            user_info,
            video_duration,
            comment_count,
            abstract_content,
          } = video
          const {
            title,
            item_id_str: unique_id,
            image_url: cover_url,
          } = repost_info || {}
          const {
            avatar_url: avatar,
            name: username,
            user_id: uid,
          } = user_info || {}
          return (
            <ArticleCard
              key={unique_id}
              title={title}
              unique_id_str={unique_id}
              cover_url={cover_url}
              user_info={{ avatar, username }}
              video_duration={video_duration}
              comment_count={comment_count}
              abstract_content={abstract_content}
              uid={uid}
              series_id={series_id}
            />
          )
        }),
      2
    ).map((group, index) => {
      return (
        <SwiperSlide key={index}>
          <div>{group}</div>
        </SwiperSlide>
      )
    })
  }, [tabNow, articles, videos])
  return (
    <div className="articles">
      <SubNav tabs={tabs} align="left" onClick={handleClick} tabNow={tabNow} />
      {cards.length > 0 && (
        <Link href={`/auto/series/${series_id}/${tabNow}`}>
          <span
            className="show-more"
            onClick={(eve) => {
              sendTeaCommEvent('click_series_group_module_more', {
                car_series_id: series_id,
                sub_tab: tabNow === 'article' ? '文章' : '视频',
              })
            }}
          >
            更多{tabNow === 'article' ? '文章' : '视频'}
            <img src={show_more_icon} />
          </span>
        </Link>
      )}
      {cards.length === 0 && (
        <span className="no-article">
          <img src={empty_icon} />
          暂无文章
        </span>
      )}
      <Swiper {...params}>
        {cards}
        <div ref={paginationRef} />
      </Swiper>
      <style jsx>
        {`
          .articles {
            padding: 16px;
            width: 540px;
            height: 290px;
            background-color: white;
            position: relative;
          }
          .show-more {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #606370;
            font-size: 12px;
            line-height: 1.5;
            position: absolute;
            top: 20px;
            right: 16px;
          }
          .show-more > img {
            width: 14px;
            height: 14px;
            object-fit: cover;
            object-position: center;
          }

          .no-article {
            position: absolute;
            left: 230px;
            top: 111px;
            color: #606370;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .no-article > img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            object-position: center;
          }

          :global(.articles .swiper-container) {
            height: 236px;
          }
          :global(.articles .swiper-pagination-bullets) {
            position: absolute;
            bottom: 12px;
            text-align: center;
            cursor: pointer;
            z-index: 1;
          }
          :global(.articles .swiper-pagination-bullet) {
            width: 20px;
            height: 4px;
            border-radius: 0;
            background-color: #c9cbd6;
            box-sizing: content-box;
            position: relative;
          }
          :global(.articles .swiper-pagination-bullet::after) {
            content: '';
            position: absolute;
            opacity: 0;
            top: -6px;
            left: 0;
            height: 16px;
            width: 100%;
          }
          :global(.articles .swiper-pagination-bullet-active) {
            width: 20px;
            background-color: #1f2129;
          }
          :global(.articles .swiper-pagination-bullet:focus) {
            border: none;
            outline: none;
          }
        `}
      </style>
    </div>
  )
}
